import moment from "moment";
import AuthService from "../services/authenticationService";
import { detect } from "detect-browser";
import paymentLogoCards from "./PaymentLogo";

export const isIterableArray = (array) =>
  Array.isArray(array) && !!array.length;

export const getSize = (size) => {
  if (size < 1024) {
    return `${size} Byte`;
  } else if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(2)} KB`;
  } else {
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  }
};

export const getRandomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const getColor = (name, dom = document.documentElement) => {
  return getComputedStyle(dom)
    .getPropertyValue(`--falcon-${name}`)
    .trim();
};

//===============================
// Breakpoints
//===============================
export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1540,
};

//===============================
// Store
//===============================
export const getItemFromStore = (key, defaultValue, store = localStorage) =>
  JSON.parse(store.getItem(key)) || defaultValue;
export const setItemToStore = (key, payload, store = localStorage) =>
  store.setItem(key, JSON.stringify(payload));
export const getStoreSpace = (store = localStorage) =>
  parseFloat(
    (
      escape(encodeURIComponent(JSON.stringify(store))).length /
      (1024 * 1024)
    ).toFixed(2)
  );

export const getItemFromStoreNew = (
  key,
  defaultValue,
  store = localStorage
) => {
  var tempData = store.getItem(key);
  if (tempData) {
    //return JSON.parse(store.getItem(key)) || defaultValue;
    return tempData || defaultValue;
  } else {
    return defaultValue;
  }
};
export const getStoreData = (strivdval, str_nda) => {
  if (strivdval) {
    var apiParam = { strivdval: strivdval, str_nda: str_nda };
    AuthService.get_store_data(apiParam).then(
      (res) => {
        return res.items;
      },
      (error) => {
        AuthService.logout();
      }
    );
  } else {
    return {};
  }
};
//===============================
// Cookie
//===============================
export const getCookieValue = (name) => {
  const value = document.cookie.match(
    "(^|[^;]+)\\s*" + name + "\\s*=\\s*([^;]+)"
  );
  return value ? value.pop() : null;
};

export const createCookie = (name, value, cookieExpireTime) => {
  const date = new Date();
  date.setTime(date.getTime() + cookieExpireTime);
  const expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + value + expires + "; path=/";
};

//===============================
// Moment
//===============================
export const getDuration = (startDate, endDate) => {
  if (!moment.isMoment(startDate))
    throw new Error(
      `Start date must be a moment object, received ${typeof startDate}`
    );
  if (endDate && !moment.isMoment(endDate))
    throw new Error(
      `End date must be a moment object, received ${typeof startDate}`
    );

  return `${startDate.format("ll")} - ${
    endDate ? endDate.format("ll") : "Present"
  } • ${startDate.from(endDate || moment(), true)}`;
};

export const numberFormatter = (number, fixed = 2) => {
  // Nine Zeroes for Billions
  return Math.abs(Number(number)) >= 1.0e9
    ? (Math.abs(Number(number)) / 1.0e9).toFixed(fixed) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(number)) >= 1.0e6
    ? (Math.abs(Number(number)) / 1.0e6).toFixed(fixed) + "M"
    : // Three Zeroes for Thousands
    Math.abs(Number(number)) >= 1.0e3
    ? (Math.abs(Number(number)) / 1.0e3).toFixed(fixed) + "K"
    : Math.abs(Number(number)).toFixed(fixed);
};

//===============================
// Colors
//===============================
export const hexToRgb = (hexValue) => {
  let hex;
  hexValue.indexOf("#") === 0
    ? (hex = hexValue.substring(1))
    : (hex = hexValue);
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
    hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b)
  );
  return result
    ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16),
      ]
    : null;
};

export const rgbColor = (color = colors[0]) => `rgb(${hexToRgb(color)})`;
export const rgbaColor = (color = colors[0], alpha = 0.5) =>
  `rgba(${hexToRgb(color)},${alpha})`;

export const colors = [
  "#2c7be5",
  "#00d97e",
  "#e63757",
  "#39afd1",
  "#fd7e14",
  "#02a8b5",
  "#727cf5",
  "#6b5eae",
  "#ff679b",
  "#f6c343",
];

export const themeColors = {
  primary: "#2c7be5",
  secondary: "#748194",
  success: "#00d27a",
  info: "#27bcfd",
  warning: "#f5803e",
  danger: "#e63757",
  light: "#f9fafd",
  dark: "#0b1727",
  buttonbg: "#132238",
  buttontext: "#2774e5",
};

export const grays = {
  white: "#fff",
  100: "#f9fafd",
  200: "#edf2f9",
  300: "#d8e2ef",
  400: "#b6c1d2",
  500: "#9da9bb",
  600: "#748194",
  700: "#5e6e82",
  800: "#4d5969",
  900: "#344050",
  1000: "#232e3c",
  1100: "#0b1727",
  black: "#000",
};

export const darkGrays = {
  white: "#fff",
  1100: "#f9fafd",
  1000: "#edf2f9",
  900: "#d8e2ef",
  800: "#b6c1d2",
  700: "#9da9bb",
  600: "#748194",
  500: "#5e6e82",
  400: "#4d5969",
  300: "#344050",
  200: "#232e3c",
  100: "#0b1727",
  black: "#000",
};

export const getGrays = (isDark) => (isDark ? darkGrays : grays);

export const rgbColors = colors.map((color) => rgbColor(color));
export const rgbaColors = colors.map((color) => rgbaColor(color));

//===============================
// Echarts
//===============================
export const getPosition = (pos, params, dom, rect, size) => ({
  top: pos[1] - size.contentSize[1] - 10,
  left: pos[0] - size.contentSize[0] / 2,
});

//===============================
// E-Commerce
//===============================
export const calculateSale = (base, less = 0, fix = 2) =>
  (base - base * (less / 100)).toFixed(fix);
export const getTotalPrice = (cart, baseItems) =>
  cart.reduce((accumulator, currentValue) => {
    const { id, quantity } = currentValue;
    const { price, sale } = baseItems.find((item) => item.id === id);
    return accumulator + calculateSale(price, sale) * quantity;
  }, 0);

//===============================
// Helpers
//===============================
export const getPaginationArray = (totalSize, sizePerPage) => {
  const noOfPages = Math.ceil(totalSize / sizePerPage);
  const array = [];
  let pageNo = 1;
  while (pageNo <= noOfPages) {
    array.push(pageNo);
    pageNo = pageNo + 1;
  }
  return array;
};

export const capitalize = (str) =>
  (str.charAt(0).toUpperCase() + str.slice(1)).replace(/-/g, " ");

export const routesSlicer = ({ routes, columns = 3, rows }) => {
  const routesCollection = [];
  routes.map((route) => {
    if (route.children) {
      return route.children.map((item) => {
        if (item.children) {
          return routesCollection.push(...item.children);
        }
        return routesCollection.push(item);
      });
    }
    return routesCollection.push(route);
  });

  const totalRoutes = routesCollection.length;
  const calculatedRows = rows || Math.ceil(totalRoutes / columns);
  const routesChunks = [];
  for (let i = 0; i < totalRoutes; i += calculatedRows) {
    routesChunks.push(routesCollection.slice(i, i + calculatedRows));
  }
  return routesChunks;
};

export const getPageName = (pageName) => {
  return window.location.pathname.split("/").slice(-1)[0] === pageName;
};

export const copyToClipBoard = (textFieldRef) => {
  const textField = textFieldRef.current;
  textField.focus();
  textField.select();
  document.execCommand("copy");
};

export const getTodayDate = () => {
  var today = new Date();
  var month = today.getMonth() + 1;
  var twoDigitMonth = month >= 10 ? month : "0" + month;
  var twoDigitDate =
    today.getDate() >= 10 ? today.getDate() : "0" + today.getDate();
  var tdate = today.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
  return tdate;
};

export const getUTCTodayDate = () => {
  var today = new Date();
  var month = today.getUTCMonth() + 1;
  var twoDigitMonth = month >= 10 ? month : "0" + month;
  var twoDigitDate =
    today.getUTCDate() >= 10 ? today.getUTCDate() : "0" + today.getUTCDate();
  var utcDate =
    today.getUTCFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
  return utcDate;
};

export const getFromDate = (intval) => {
  var someDate = new Date();
  someDate.setDate(someDate.getDate() - intval);
  var month = someDate.getMonth() + 1;
  var twoDigitMonth = month >= 10 ? month : "0" + month;
  var twoDigitDate =
    someDate.getDate() >= 10 ? someDate.getDate() : "0" + someDate.getDate();
  var fdate = someDate.getFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
  return fdate;
};

export const getFromUTCDate = (intval) => {
  var someDate = new Date();
  someDate.setDate(someDate.getUTCDate() - intval);
  var month = someDate.getUTCMonth() + 1;
  var twoDigitMonth = month >= 10 ? month : "0" + month;
  var twoDigitDate =
    someDate.getUTCDate() >= 10
      ? someDate.getUTCDate()
      : "0" + someDate.getUTCDate();
  var fdate =
    someDate.getUTCFullYear() + "-" + twoDigitMonth + "-" + twoDigitDate;
  return fdate;
};

export const compareTwoArray = (array1, array2) => {
  if (array1.length === array2.length) {
    let isSame = [];
    array1.map((array1item) => {
      if (array2.includes(array1item)) {
        isSame = [...isSame, true];
      } else {
        isSame = [...isSame, false];
      }
    });

    return !isSame.includes(false); // if true that time same but false so not same
  } else if (array1.length > array2.length) {
    let isSame = [];
    array1.map((array1item) => {
      if (array2.includes(array1item)) {
        isSame = [...isSame, true];
      } else {
        isSame = [...isSame, false];
      }
    });

    return !isSame.includes(false); // if true that time same but false so not same
  } else {
    let isSame = [];
    array2.map((array2) => {
      if (array1.includes(array2)) {
        isSame = [...isSame, true];
      } else {
        isSame = [...isSame, false];
      }
    });

    return !isSame.includes(false); // if true that time same but false so not same
  }
};

export const compareObject = (object1, object2) => {
  let object1Key = object1 ? Object.keys(object1) : [];
  let object2Key = object2 ? Object.keys(object2) : [];

  // let isArraySame = compareTwoArray(object1Key, object2Key);

  if (object1Key.length >= object2Key.length) {
    let isSame = [];
    object1Key.map((o1Item) => {
      if (object1[o1Item].trim() === object2[o1Item].trim()) {
        isSame = [...isSame];
      } else {
        isSame = [...isSame, "NOT SAME"];
      }
    });
    if (isSame.length > 0) {
      return false;
    } else {
      return true;
    }
  } else {
    let isSame = [];
    object2Key.map((o2Item) => {
      if (object2[o2Item].trim() === object1[o2Item].trim()) {
        isSame = [...isSame];
      } else {
        isSame = [...isSame, "NOT SAME"];
      }
    });
    if (isSame.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};

export const customSubString = (
  stringValue,
  length,
  type,
  startLength,
  endLength
) => {
  startLength = startLength || 0;
  endLength = endLength || 0;
  let value = "";
  if (type === "end") {
    value = stringValue.substring(
      stringValue.length - length,
      stringValue.length
    );
  } else if (type === "start") {
    value = stringValue.substring(0, length);
  } else {
    value = stringValue.substring(startLength, endLength);
  }

  return { value };
};

export const GetDateDefference = (date_1, date_2) => {
  let date1 = new Date(date_1);
  let date2 = new Date(date_2);

  // To calculate the time difference of two dates
  let Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

  return Difference_In_Days;
};

export const removeDuplicateObjectBykey = (data, keyName) => {
  const uniqueArray = data.filter((obj, index, self) => {
    return index === self.findIndex((o) => o[keyName] === obj[keyName]);
  });

  return uniqueArray;
};

export const CaptitalizeString = (formatItem) => {
  return formatItem
    ?.split(" ")
    .map(
      (word) =>
        `${word.substring(0, 1).toUpperCase()}${word.substring(1, word.length)}`
    )
    ?.join(" ");
};

export const getDateUsingNumber = (defaultDate, daysToAdd) => {
  const today = new Date(defaultDate);
  daysToAdd = daysToAdd < 1 ? daysToAdd : daysToAdd || -7; // default value give a 7 days before date.
  const targetDate = new Date(
    today.getTime() + daysToAdd * 24 * 60 * 60 * 1000
  );
  const formattedDate = targetDate.toISOString().slice(0, 10); // YYYY-MM-DD format

  return { targetDate, formattedDate };
};

export const IsValueSame = (a, b) => {
  // in this function nested object or array should not need else annser will wrong. used in nadapayment surcharge;

  let getAkeys = Object.keys(a);
  let getBkeys = Object.keys(b);
  let isSame = [];

  getAkeys.map((aKey) => {
    getBkeys.map((bKey) => {
      if (aKey == bKey) {
        if (a[aKey] == b[bKey]) {
          isSame = [...isSame, true];
        } else {
          isSame = [...isSame, false];
        }
      }
    });
  });

  return !isSame.includes(false);
};

export const isParsable = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const GetParamterFromLink = (paramKey) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(paramKey);
};

export const getTimeDifference = (date1, date2) => {
  // Convert dates to milliseconds
  const date1Millis = new Date(date1).getTime();
  const date2Millis = new Date(date2).getTime();

  // Calculate the difference in milliseconds
  const differenceMillis = Math.abs(date2Millis - date1Millis);

  // Calculate difference in seconds, minutes, and hours
  const differenceSeconds = Math.floor(differenceMillis / 1000);
  const differenceMinutes = Math.floor(differenceSeconds / 60);
  const differenceHours = Math.floor(differenceMinutes / 60);

  const remainingSeconds = differenceSeconds % 60;
  const remainingMinutes = differenceMinutes % 60;

  // Construct the result string
  let result = `${remainingSeconds} seconds`;
  if (differenceMinutes > 0) {
    result = `${remainingMinutes} minutes ${remainingSeconds} seconds`;
  }
  if (differenceHours > 0) {
    result = `${differenceHours} hours ${remainingMinutes} minutes`;
  }

  return result;
};

export function formatDate(date) {
  const dateClone = new Date(date);
  const year = dateClone.getFullYear();
  const month = String(dateClone.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(dateClone.getDate()).padStart(2, "0");
  const hours = String(dateClone.getHours()).padStart(2, "0");
  const minutes = String(dateClone.getMinutes()).padStart(2, "0");
  const seconds = String(dateClone.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
}

// const currentDate = new Date();
// const yesterday = new Date(currentDate);
// yesterday.setDate(currentDate.getDate() - 1);

// console.log("Formatted Current Date and Time:", formatDate(currentDate));
// console.log("Formatted Yesterday's Date with Current Time:", formatDate(yesterday));
function detectBrowser() {
  const browser = detect();

  let isChrome =
    browser.name.toLowerCase().includes("chrome") &&
    !browser.name.toLowerCase().includes("opr");
  let isFirefox = browser.name.toLowerCase().includes("firefox");
  let isSafari =
    browser.name.toLowerCase().includes("safari") &&
    !browser.name.toLowerCase().includes("chrome");
  let isIE =
    browser.name.toLowerCase().includes("msie") ||
    browser.name.toLowerCase().includes("rv:");
  let isOpera = browser.name.toLowerCase().includes("opr");

  return {
    chrome: isChrome,
    firefox: isFirefox,
    safari: isSafari,
    ie: isIE,
    opera: isOpera,
  };
}

export function reloadPage() {
  const browser = detectBrowser();
  if (browser.chrome || browser.safari) {
    window.location.href = window.location.href; // Reload using window.location.href
  } else {
    window.location.reload(true); // Use location.reload(true) for other browsers
  }
}

export const hostName = (url) => {
  if (url.includes("localhost")) {
    return "localhost";
  } else if (url.includes("qa")) {
    return "qa";
  } else {
    return "production";
  }
};

export const findCardLogo = (card_name) => {
  let temp_card_name = card_name?.replace(/\s/g, "")?.toLowerCase();
  const isExist = paymentLogoCards.find((item) => {
    let paymentName = item.name?.replace(/\s/g, "")?.toLowerCase();
    if (paymentName === temp_card_name) {
      return item;
    }
  });
  return isExist;
};

export const listStorageKeys = (storageType) => {
  const storage = storageType === "local" ? localStorage : sessionStorage;
  const keys = [];
  for (let i = 0; i < storage.length; i++) {
    keys.push(storage.key(i));
  }

  return keys;
};

export const validatePassword = (password)=> {
  const minLength = /.{9,}/;
  const hasLowercase = /[a-z]/;
  const hasUppercase = /[A-Z]/;
  const hasNumber = /\d/;
  const hasSymbol = /[!@#$%^&*]/;

  const errors = [];

  if (!hasLowercase.test(password)) {
    errors.push("Password must contain at least one lowercase letter.");
  }

  if (!hasUppercase.test(password)) {
    errors.push("Password must contain at least one uppercase letter.");
  }

  if (!hasNumber.test(password)) {
    errors.push("Password must contain at least one number.");
  }

  if (!hasSymbol.test(password)) {
    errors.push("Password must contain at least one symbol (!@#$%^&*).");
  }

  if (!minLength.test(password)) {
    errors.push("Password must be at least 9 characters long.");
  }

  return errors;
}

export const replaceWhitespaceWithUnderscore = (str) => {
  return str.replace(/\s+/g, "_");
};